/* eslint-disable */
/**
 * @fileoverview Dashboard Header Component
 *
 * Displays the welcome message and current date/time with Command Center styling.
 *
 * @author Clockwise CPA Development Team
 * @version 2.0.0
 */

import React, { memo, useMemo } from 'react';
import { FiCalendar } from 'react-icons/fi';
import '../../../styles/PageHeader.css';

/**
 * DashboardHeader Component
 *
 * @param {Object} props
 * @param {Object} props.user - Current user object
 * @param {Date} props.currentDateTime - Current date/time
 * @returns {JSX.Element}
 */
const DashboardHeader = memo(({ user, currentDateTime }) => {
    // Format date properly
    const formattedDate = useMemo(() => currentDateTime.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }), [currentDateTime]);

    const formattedTime = useMemo(() => currentDateTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
    }), [currentDateTime]);

    const firstName = user.first_name || user.username;

    return (
        <header className="page-header-unified header-blue element-to-hide">
            <div className="page-header-content">
                <div className="page-header-left">
                    <div className="page-header-title-row">
                        <h1 className="page-header-title">Welcome back, {firstName}</h1>
                    </div>
                    <p className="page-header-subtitle">
                        Here's what's happening with your account today.
                    </p>
                </div>

                <div className="page-header-right">
                    <div className="page-header-meta">
                        <span className="page-header-meta-primary">{formattedDate}</span>
                        <span className="page-header-meta-secondary">
                            <FiCalendar style={{ marginRight: 4, verticalAlign: 'middle' }} />
                            {formattedTime}
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
});

DashboardHeader.displayName = 'DashboardHeader';

export default DashboardHeader;
